/**
 * api管理
 */
import request from '../utils/request.js'
export default {
  // 登录
  login (params) {
    return request('/api/login', params, 'post')
  },
  // 发送短信
  sendCode (params) {
    return request('/api/sendCode', params, 'post')
  },
  // 根据token获取用户信息
  getUserInfo (params) {
    return request('/api/getUserInfo', params, 'get')
  },
  // 获取题目
  getData (params) {
    return request('/api/getData', params, 'get')
  },
  // 提交答案
  postData (params) {
    return request('/api/postData', params, 'post')
  },
  // 排行榜
  getCharts (params) {
    return request('/api/getCharts', params, 'get')
  },
  // 关闭页面
  getConfig (params) {
    return request('/api/getConfig', params, 'get')
  },
  // 提交地址
  submitAddress (params) {
    return request('/api/addAddress', params, 'post')
  }
}
